<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <div v-if="properPreparation == true">
                <v-row>
                    <v-card elevation="12"
                        style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                        <v-card style="margin-top: 20svh; margin-left: 5svw; margin-right: 5svw; border: 1px solid #059BCA; border-radius:
                                    9px; box-shadow: none;">
                            <p
                                style="padding-top: 5%; padding-bottom: 5%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px; font-weight: 400;">
                                Acuda a su cita médica prevista
                            </p>
                        </v-card>
                        <p
                            style="margin-top: 15svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; text-align: center; font-size: 16px; font-weight: 300;">
                            Proceso finalizado</p>
                        <p
                            style="margin-top: 3svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; font-style: normal; color: #3F616C; text-align: center; font-size: 24px; font-weight: 300;">
                            ¡Gracias por colaborar!</p>
                    </v-card>
                </v-row>
            </div>
        </v-container>
    </v-main>
</template>

<script>
import CardNav from './CardNav.vue';
import { nextScreen } from '../router/utils.js';

export default {
    name: 'ProcessCompleted',
    components: {
        CardNav
    },
    data() {
        return {
            proper: false
        }
    },
    computed: {
        properPreparation: {
            get: function () {
                return this.proper;
            },
            set: function (newValue) {
                this.proper = newValue;
            }
        },
    },
    methods: {
        matchHeight() {
            this.properPreparation = this.$route.params.generic;
            if (!this.properPreparation) {
                nextScreen(this.$router, '/endtreatmenthospital');
            }
        },
    },
    mounted() {
        this.matchHeight();
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/ProcessCompleted.vue